export default {
  emojis(state) {
    return state.emojis;
  },
  emojisIsEnabled(state){
    return state.emojisIsEnabled;
  }
};
